import React from 'react'
import Loading from '../../../../../molecules/Loading'
import ErrorDisplay from '../../../../../molecules/ErrorDisplay'
import AdminPage from '../../../shared/AdminPage'
import OperationalTable from '../../../../../organisms/OperationalTable'
import { useGetThingSchemas } from '../../../../../../api/things'
import ThingSchemaModal from './thingSchemaModal'

const ContentView = () => {
  const levelTypeMap = {
    1: 'Account',
    3: 'Product',
    201: 'Client'
  }

  const { data: rawData, isLoading } = useGetThingSchemas([1, 3, 201])
  const data = isLoading ? [] : rawData.schema
  const defaultColumnConfig = {
    columns: [
      { Header: 'Id', accessor: 'thingConfigurationId', type: 'number' },
      {
        Header: 'Level Type',
        type: 'string',
        Cell: ({ row }) => levelTypeMap[row.original.levelTypeId]
      },
      { Header: 'Category', accessor: 'category', type: 'string' },
      { Header: 'Code', accessor: 'code', type: 'string' },
      { Header: 'Name', accessor: 'name', type: 'string' },
      { Header: 'Description', accessor: 'description', type: 'string' }
    ],
    defaultSort: [{ id: 'thingConfigurationId', desc: false }]
  }
  const [thingModalOpen, setThingModalOpen] = React.useState(false)
  const [thingSchema, setThingSchema] = React.useState(null)
  if (isLoading) {
    return <Loading />
  }
  if (data.length === 0) {
    return <ErrorDisplay soft error='No Schemas found' />
  }
  return (
    <AdminPage>
      <>
        {thingSchema && (
          <ThingSchemaModal
            open={thingModalOpen}
            onClose={() => setThingModalOpen(false)}
            thingSchema={thingSchema}
          />
        )}
        <OperationalTable.Wrapper>
          <OperationalTable
            variant='v2'
            mode='auto'
            itemName='Content Types'
            columns={defaultColumnConfig.columns}
            defaultSort={defaultColumnConfig.defaultSort}
            data={data}
            total={data.length}
            onRowClick={(row) => {
              setThingModalOpen(true)
              setThingSchema(row.original)
            }}
          />
        </OperationalTable.Wrapper>
      </>
    </AdminPage>
  )
}

export default ContentView
